var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.hideReplyBtn,
              expression: "hideReplyBtn",
            },
          ],
          staticClass: "my-reply",
          on: { click: _vm.inputFocus },
        },
        [
          _c("el-avatar", {
            staticClass: "header-img",
            attrs: { size: 36, src: _vm.myHeader },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showReply,
                  expression: "!showReply",
                },
              ],
              staticClass: "reply-info",
            },
            [
              _c("div", {
                staticClass: "reply-input pointer",
                attrs: {
                  tabindex: "0",
                  contenteditable: "true",
                  id: "replyInput",
                  spellcheck: "false",
                  placeholder: "请输入您的评论",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleComment()
                  },
                  focus: _vm.showReplyBtn,
                  input: function ($event) {
                    return _vm.onDivInput($event)
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.showReply
            ? _c(
                "div",
                { staticClass: "reply-ueditor" },
                [
                  _c("ueditorFrom", {
                    ref: "ueditorFrom",
                    tag: "ueditor-form",
                    attrs: {
                      border: true,
                      height: "120px",
                      type: "simple",
                      headers: true,
                      content: _vm.formData.describe,
                      placeholder: "发表您的看法...",
                    },
                    on: { input: _vm.ueditorEdit },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showReply,
                  expression: "showReply",
                },
              ],
              staticClass: "reply-btn-box",
            },
            [
              _c(
                "el-button",
                { staticClass: "reply-btn", on: { click: _vm.cancelComment } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "primary" },
                  on: { click: _vm.sendComment },
                },
                [_vm._v("评论")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.comments.length
        ? _c(
            "div",
            { staticClass: "reply-father" },
            _vm._l(_vm.comments, function (item, i) {
              return _c(
                "div",
                { key: i, staticClass: "author-title" },
                [
                  _c("el-avatar", {
                    staticClass: "header-img",
                    attrs: { size: 36, src: item.member.avatar },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "author-info" }, [
                    _c("span", { staticClass: "author-name" }, [
                      _vm._v(_vm._s(item.member.name)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "author-time" }, [
                      _vm._v(_vm._s(item.updated_at)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon-btn icon-btn-header" }, [
                    _vm.myId !== item.member.id
                      ? _c(
                          "div",
                          {
                            staticClass: "pointer lh-center",
                            on: {
                              click: function ($event) {
                                return _vm.showReplyEvt(item, 1)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "iconfont iconcebianlan-luntanzhongxin",
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("回复")]),
                          ]
                        )
                      : _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "edit-name pointer lh-center",
                              on: {
                                click: function ($event) {
                                  return _vm.eidtReply(item)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "iconfont iconbianji" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("编辑")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pointer lh-center",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteReply(item)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "iconfont iconshanchu1" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("删除")]),
                            ]
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "talk-box" }, [
                    _c("p", { staticClass: "content" }, [
                      _c("span", {
                        staticClass: "reply",
                        domProps: { innerHTML: _vm._s(item.describe) },
                        on: {
                          click: function ($event) {
                            return _vm.previewPicture($event)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "reply-box" },
                    _vm._l(item.children, function (reply, j) {
                      return _c(
                        "div",
                        { key: j, staticClass: "author-item" },
                        [
                          _c("el-avatar", {
                            staticClass: "header-img",
                            attrs: { size: 26, src: reply.member.avatar },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "author-info" }, [
                            _c("span", { staticClass: "author-name" }, [
                              _vm._v(_vm._s(reply.member.name)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "author-time" }, [
                              _vm._v(_vm._s(reply.updated_at)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-btn" }, [
                            _vm.myId !== reply.member.id
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "pointer lh-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showReplyEvt(reply, 2)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont iconcebianlan-luntanzhongxin",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("回复")]),
                                  ]
                                )
                              : _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "edit-name pointer lh-center",
                                      on: {
                                        click: function ($event) {
                                          return _vm.eidtReply(reply)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "iconfont iconbianji",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("编辑")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pointer lh-center",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteReply(reply)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "iconfont iconshanchu1",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("删除")]),
                                    ]
                                  ),
                                ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "talk-box" }, [
                            _c("p", [
                              _c("span", {
                                staticClass: "reply",
                                domProps: { innerHTML: _vm._s(reply.describe) },
                                on: {
                                  click: function ($event) {
                                    return _vm.previewPicture($event)
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "reply-box" }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm._inputShow(i),
                          expression: "_inputShow(i)",
                        },
                      ],
                      staticClass: "my-reply my-comment-reply",
                    },
                    [
                      _c("el-avatar", {
                        staticClass: "header-img",
                        attrs: { size: 40, src: _vm.myHeader },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "reply-info" }, [
                        _c("div", {
                          staticClass: "reply-input reply-comment-input",
                          attrs: {
                            tabindex: "0",
                            contenteditable: "true",
                            spellcheck: "false",
                            placeholder: "输入评论...",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onDivInput($event)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "reply-btn-box" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "reply-btn",
                              attrs: { size: "medium", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.sendCommentReply(i, _vm.j)
                                },
                              },
                            },
                            [_vm._v("发表评论")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.comments.length
        ? _c(
            "div",
            { staticClass: "default" },
            [_c("default-page", { attrs: { index: 17, "min-height": 300 } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }